<template>
	<ion-page>
		<div class="forceupdate__wrapper">
			<img src="/assets/trackiwi_logo.png" class="forceupdate__logo" />

			<div class="forceupdate__text">
				<p>Wir führen Wartungsarbeiten durch und sind in Kürze zurück.</p>
			</div>

			<div class="forceupdate__footer">
				<ion-button :disabled="loading" class="text--large pill" color="secondary" @click="retryButtonClicked">{{ buttonLabel }}</ion-button>
			</div>
		</div>
	</ion-page>
</template>

<script setup>
import { Capacitor } from "@capacitor/core"
import { StatusBar, Style } from "@capacitor/status-bar"
import { IonPage, IonButton, onIonViewDidEnter } from "@ionic/vue"
import { onMounted, ref } from "vue"
import { App } from "@capacitor/app"
import { useApiStore } from "@/stores/api"

const clickCounter = ref(0)
const loading = ref(false)
const buttonLabel = ref("Erneut versuchen")

const retryButtonClicked = async () => {
	loading.value = true
	await checkMaintenance()
	loading.value = false
	clickCounter.value++
	if (clickCounter.value >= 3) {
		buttonLabel.value = ["Sind wir bald da?", "Wie lange dauert's noch?", "Ich hab' Hunger"][clickCounter.value % 3]
	}
}

const api = useApiStore()
const updateVersion = ref(null)

const setStatusBarColor = () => {
	if (Capacitor.isNativePlatform()) {
		StatusBar.setStyle({ style: Style.Dark })
	}
}

onMounted(async () => {
	setStatusBarColor()
	checkMaintenance()
})

onIonViewDidEnter(() => {
	setStatusBarColor()
})

App.addListener("appStateChange", ({ isActive }) => {
	if (isActive) {
		setStatusBarColor()
		checkMaintenance()
	}
})

// check, if version is still deprecated
const checkMaintenance = async () => {
	try {
		const response = await api.dispatchWebsiteApiCall("get", "/api/app/checkupdate", { ts: Date.now() })

		if (!response.data.force_update) {
			window.location.href = "/"
		}

		updateVersion.value = response.data.latest_version
	} catch (e) {
		return
	}
}
</script>

<style scoped>
.forceupdate__wrapper {
	position: fixed;
	display: grid;
	grid-template-columns: 100%;
	grid-template-rows: 20% calc(80% - 200px) 200px;
	width: 100vw;
	height: 100vh;
	min-height: 650px;
	background-color: #193729;
	background-image: url("/assets/login-background.jpg");
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
}

.forceupdate__logo {
	width: 90%;
	max-width: 180px;
	align-self: end;
	justify-self: center;
}

.forceupdate__text {
	width: 90%;
	max-width: 300px;
	align-self: center;
	justify-self: center;
	text-align: center;
	font-size: 1.3em;
	font-weight: 600;
	color: #fff;
}

.forceupdate__footer {
	width: auto;
	align-self: center;
	justify-self: center;
	color: #fff;
	text-align: center;
}
</style>
